import react from "react";
import { NavLink } from "react-router-dom";

const Footer = () => {
  const menuData = [
    {
      url: '/',
      menu: 'home',
    },
    {
      url: '/news',
      menu: 'news',
    },
    {
      url: '/gold',
      menu: 'gold rates',
    },
    {
      url: '/silver',
      menu: 'silver rates',
    },
    {
      url: '/currency',
      menu: 'currency',
    },
  ]

  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            <div className="main-box">
              <div className="box">
                <div className="content">
                  <div className="logo">
                    <NavLink to="/" aria-label="footer logo">
                      <img src="https://makawanacs.com/themes/custom/mcs/img/footer-logo.png" alt="footer logo" />
                    </NavLink>
                  </div>
                  <p>Your ultimate destination for precious metals and financial insights—our website offers real-time gold and silver rates, an intuitive currency converter, and the latest market news. Stay informed, track trends, and make smart investment decisions all in one place.</p>
                </div>
              </div>
              <div className="box">
                <div className="content">
                  <div className="main-heading">
                    <h3>Quick Links</h3>
                  </div>
                  <ul className="menu_item">
                    {
                      menuData && menuData.map(({ url, menu }, index) => {
                        return (
                          <li key={index}>
                            <NavLink
                              to={url}
                              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                            >
                              {menu}
                            </NavLink>
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
              </div>
              <div className="box">
                <div className="content">
                  <div className="main-heading">
                    <h3>Contact us</h3>
                  </div>
                  <p>
                    Have questions or need support? Reach out to us at Admin@mcs.com
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="content">
                  <div className="main-heading">
                    <h3>Stay Connected</h3>
                  </div>
                  <p>Connect with us for updates and insights:</p>
                  <div className="share">
                    <ul>
                      <li>
                        <a href="#">
                          <i className="fa-brands fa-facebook-f"></i>
                          <span className="text text-capitalize">facebook</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa-brands fa-instagram"></i>
                          <span className="text text-capitalize">Instagram</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <svg aria-hidden="true" className="e-font-icon-svg e-fab-x-twitter" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                            <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z">
                            </path>
                          </svg>
                          <span className="text text-capitalize">Twitter</span>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fa-brands fa-linkedin-in"></i>
                          <span className="text text-capitalize">LinkedIn</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="footer-rights">
              <p>© Copyrights 2025 Today Gold Rate All rights reserved. | Developed By </p>
              <a href="https://makawanacs.com/" target="_blank">MAKAWANA CONSULTANCY SERVICES</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer;